// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
var define;
var is_node = typeof module=='object' && module.exports;
if (is_node)
{
    define = require('../../../../../util/require_node.js').define(module,
        '..');
}
else
    define = self.define;
define([], ()=>{
const E = {};
E.intro = [['div',
    [['h1',
        [`vi Basics`],
        {className: `title`},
    ],
    ['p',
        [['b',
            [`Improvements? Suggestions?`],
        ],
        ` email `,
        ['a',
            [`dna@hola.org`],
            {href: `mailto:dna@hola.org`},
        ],
        ` `],
    ]],
    {className: `head`},
]];
E.data = [
    {
        id: 'minimal',
        title: `Minimal`,
        tag: 'h2',
        short: `Minimal`,
        html: [],
    },
    {
        id: 'hola',
        title: `Hola's shortcuts`,
        tag: 'h3',
        short: `Hola's shortcuts`,
        html: [['p',
            [['kbd',
                [`g`],
            ],
            ` - Open gvim (from bash)`],
        ]],
    },
    {
        id: 'minimal-files',
        title: `Files`,
        tag: 'h3',
        short: `Files`,
        html: [['p',
            [['kbd',
                [`:`],
            ],
            ['code',
                [`q`],
            ],
            ` - quit`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`w`],
            ],
            ` - save`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`x`],
            ],
            ` - save and quit`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`wqa`],
            ],
            ` - save and quit on all open windows `],
        ]],
    },
    {
        id: 'minimal-jump',
        title: `Jumping to lines`,
        tag: 'h3',
        short: `Jumping to lines`,
        html: [['p',
            [['code',
                [`401gg`],
            ],
            ` - line 401`,
            ['br'],
            ['code',
                [`gg`],
            ],
            ` - begining of file`,
            ['br'],
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`G`],
            ],
            ` - end of file`,
            ['br']],
        ]],
    },
    {
        id: 'minimal-editing',
        title: `Editing`,
        tag: 'h3',
        short: `Editing`,
        html: [['p',
            [['kbd',
                [`I`],
            ],
            ` - insert mode (to add the word `,
            ['code',
                [`hello`],
            ],
            ` at the possition of the cursor type `,
            ['code',
                [`ihello`],
            ],
            ['kbd',
                [`ESC`],
            ],
            `)`,
            ['br'],
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`A`],
            ],
            ` - add text at the end of the line (add `,
            ['code',
                [`;`],
            ],
            ` at the end of this line: `,
            ['code',
                [`A;`],
            ],
            ['kbd',
                [`ESC`],
            ],
            `)`,
            ['br'],
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`I`],
            ],
            ` - adds at beginning of line`,
            ['br'],
            ['kbd',
                [`O`],
            ],
            ` - add a new line and goto insert mode (`,
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['code',
                [`O`],
            ],
            ` add above the cursor)`,
            ['br'],
            ['kbd',
                [`ESC`],
            ],
            ` - exit edit mode`,
            ['br'],
            ['kbd',
                [`x`],
            ],
            ` - delete a char`,
            ['br'],
            ['code',
                [`dd`],
            ],
            ` - delete a line (`,
            ['code',
                [`dw`],
            ],
            ` delete a word)`,
            ['br'],
            ['code',
                [`yy`],
            ],
            ` - copy a line into buffer (`,
            ['code',
                [`yw`],
            ],
            ` copy a word)`,
            ['br'],
            ['kbd',
                [`p`],
            ],
            ` - paste buffer (`,
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`P`],
            ],
            ` paste before cursor)`,
            ['br']],
        ]],
    },
    {
        id: 'basics',
        title: `Basics`,
        tag: 'h2',
        short: `Basics`,
        html: [],
    },
    {
        id: 'basics-editing',
        title: `Editing`,
        tag: 'h3',
        short: `Editing`,
        html: [['p',
            [['code',
                [`"*y`],
            ],
            ` - copy to Windows buffer yunk`,
            ['br'],
            ['code',
                [`"*p`],
            ],
            ` - paste from Windows buffer`,
            ['br'],
            ['code',
                [`>>`],
            ],
            ` - indent section one tab (`,
            ['code',
                [`<<`],
            ],
            ` unindent)`,
            ['br'],
            ['kbd',
                [`=`],
            ],
            ` - automatically indent section according to language rules`,
            ['br']],
        ]],
    },
    {
        id: 'basics-movement',
        title: `Movement`,
        tag: 'h3',
        short: `Movement`,
        html: [['p',
            [['kbd',
                [`W`],
            ],
            ` - next word (`,
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`W`],
            ],
            ` search for whitespace), b and B for back word, e - end of word
                (E search for whitespace)`,
            ['br'],
            ['code',
                [`]]`],
            ],
            ` - next function (`,
            ['code',
                [`[[`],
            ],
            ` back)`,
            ['br'],
            ['code',
                [`][`],
            ],
            ` - end of function (`,
            ['code',
                [`[]`],
            ],
            ` back)`,
            ['br'],
            ['kbd',
                [`F`],
            ],
            `+`,
            ['code',
                [`<char>`],
            ],
            ` - next char (`,
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`F`],
            ],
            ` back), `,
            ['kbd',
                [`T`],
            ],
            ` and `,
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`T`],
            ],
            ` to get to before next char `],
        ]],
    },
    {
        id: 'basics-visual',
        title: `Visual`,
        tag: 'h3',
        short: `Visual`,
        html: [['p',
            [['kbd',
                [`V`],
            ],
            ` - select area`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`V`],
            ],
            ` - select area in column mode`,
            ['br'],
            ['br'],
            ` after area is selected:`,
            ['br'],
            ['kbd',
                [`D`],
            ],
            ` - delete`,
            ['br'],
            ['code',
                [`>>`],
            ],
            ` - indent section`,
            ['br'],
            ['kbd',
                [`Y`],
            ],
            ` - copy to buffer (yunk)`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`C`],
            ],
            ` - copy to Windows Buffer (you can paste with Windows
                applications) `],
        ]],
    },
    {
        id: 'basics-formatting',
        title: `Formatting`,
        tag: 'h3',
        short: `Formatting`,
        html: [['p',
            [['code',
                [`gq`],
            ],
            ` - format (wrap text) selected area`,
            ['br'],
            ['code',
                [`gqq`],
            ],
            ` - format (wrap text) current line`,
            ['br'],
            ['code',
                [`gqap`],
            ],
            ` - format current paragraph`,
            ['br'],
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`J`],
            ],
            ` - merge current line with the following line`,
            ['br']],
        ]],
    },
    {
        id: 'basics-macro_misc',
        title: `'Macro' like and
  misc`,
        tag: 'h3',
        short: `'Macro' like and misc`,
        html: [['p',
            [['code',
                [`[n][operation]`],
            ],
            ` - perform an operation n times`,
            ['br'],
            ` examples:`,
            ['br'],
            ['code',
                [`5dd`],
            ],
            ` - delete 5 lines`,
            ['br'],
            ['code',
                [`29[down arrow]`],
            ],
            ` - go down 29 lines`,
            ['br'],
            ['kbd',
                [`U`],
            ],
            ` - undo`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`R`],
            ],
            ` - redo `],
        ]],
    },
    {
        id: 'basics-telnet',
        title: `Using VIM from telnet`,
        tag: 'h3',
        short: `Using VIM from telnet`,
        html: [['p',
            [['kbd',
                [`H`],
            ],
            ['kbd',
                [`J`],
            ],
            ['kbd',
                [`K`],
            ],
            ['kbd',
                [`L`],
            ],
            ` - left down up right`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`F`],
            ],
            ` - page down (`,
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`B`],
            ],
            ` - page up) `],
        ]],
    },
    {
        id: 'basics-search_replace',
        title: `Search and
  Replace`,
        tag: 'h3',
        short: `Search and Replace`,
        html: [['p',
            [['kbd',
                [`*`],
            ],
            ` - search for the current word the cursor is on (same as `,
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`F3`],
            ],
            ` in MSDEV)`,
            ['br'],
            ['kbd',
                [`N`],
            ],
            ` - find next (`,
            ['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`N`],
            ],
            ` back)`,
            ['br'],
            ['kbd',
                [`/`],
            ],
            ['code',
                [`main`],
            ],
            ` - search for main (such as main_app)`,
            ['br'],
            ['kbd',
                [`/`],
            ],
            ['code',
                [`\\<main\\>`],
            ],
            ` - search for main as whole word`,
            ['br'],
            ['kbd',
                [`/`],
            ],
            ['code',
                [`\\<print`],
            ],
            ` - search for words starting with print (such as printf)`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`se ic`],
            ],
            ` - set the option of ignorecase`,
            ['br'],
            ['kbd',
                [`/`],
            ],
            ['code',
                [`main`],
            ],
            ` - after the set option, search for main and ignore case (such
                as Main) (`,
            ['kbd',
                [`:`],
            ],
            ['code',
                [`se noic`],
            ],
            ` - this option is: no ignorecase)`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`%s/printf/kprintf/g`],
            ],
            ` - search in all file (`,
            ['code',
                [`%`],
            ],
            ` - all the file) for printf, replace with kprintf, replace all
                occurrences (`,
            ['code',
                [`g`],
            ],
            `) - without the `,
            ['code',
                [`g`],
            ],
            ` option, if there are some occurrences in the same line - only
                the first one will be changed.`,
            ['br'],
            ` other options: ignore case (`,
            ['code',
                [`i`],
            ],
            `), conditional - ask yes/no (`,
            ['code',
                [`c`],
            ],
            `).`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`%s/add(a,\\([a-z]\\+\\))/add(a, \\1)/g`],
            ],
            ` - search in all file all occurrences of the 'add()' function
                and make sure it's second variable has a space after the
                comma. `,
            ['code',
                [`\\(`],
            ],
            ` and `,
            ['code',
                [`\\)`],
            ],
            ` group the second variable pattern and refer to it inside the
                replacement pattern by its special number `,
            ['code',
                [`\\1`],
            ],
            `. `],
        ]],
    },
    {
        id: 'advanced',
        title: `Advanced`,
        tag: 'h2',
        short: `Advanced`,
        html: [],
    },
    {
        id: 'advanced-insert_mode',
        title: `In insert mode`,
        tag: 'h3',
        short: `In insert mode`,
        html: [['p',
            [['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`X`],
            ],
            ` - auto completion.`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`P`],
            ],
            ` - complete word from current file and included files (`,
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`N`],
            ],
            ` same but without included files)`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`D`],
            ],
            ` definition of macro`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`F`],
            ],
            ` file name`,
            ['br']],
        ]],
    },
    {
        id: 'advanced-buffers',
        title: `Buffers`,
        tag: 'h3',
        short: `Buffers`,
        html: [['p',
            [['kbd',
                [`:`],
            ],
            ['code',
                [`e app.c`],
            ],
            ` - open app.c in a new buffer`,
            ['br'],
            ['code',
                [`gf`],
            ],
            ` - when standing on a file-name, opens the file in a new
                buffer`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`b 2`],
            ],
            ` - goto buffer number 2`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`buffers`],
            ],
            ` - list open buffers`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`bd`],
            ],
            ` - close buffer`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`b#`],
            ],
            ` - goto last buffer`,
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['code',
                [`6`],
            ],
            ` - goto last buffer`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`set hidden`],
            ],
            ` - Allow switching buffers without saving.`,
            ['br']],
        ]],
    },
    {
        id: 'advanced-compiling',
        title: `
  Compiling and handling errors`,
        tag: 'h3',
        short: `Compiling and handling errors (IDE like)`,
        html: [['p',
            [['kbd',
                [`Shift`],
            ],
            `+`,
            ['kbd',
                [`K`],
            ],
            ` - show the man page for current word (same as `,
            ['kbd',
                [`F1`],
            ],
            ` in Windows)`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`make`],
            ],
            ` - run make (gmake), and show results`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`cc`],
            ],
            ` - goto source of current error (:cn next error, :cp previous
                error)`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`cl`],
            ],
            ` - list the`,
            ['br']],
        ]],
    },
    {
        id: 'advanced-gdiff',
        title: `Graphical diff`,
        tag: 'h3',
        short: `Graphical diff`,
        html: [['p',
            [` startup:`,
            ['br'],
            ['code',
                [`gvim -d FILE1 unknown`],
            ],
            ['br'],
            ['br'],
            ['kbd',
                [`Ctrl`],
            ],
            `+`,
            ['kbd',
                [`W`],
            ],
            `+`,
            ['kbd',
                [`W`],
            ],
            ` - toggle between windows`,
            ['br'],
            ['br'],
            ` Make the current window part of the diff windows:`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`diffthis main.c~`],
            ],
            ['br'],
            ['br'],
            ` View the same buffer in diff mode in one window and "normal"
                in another:`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`:!cp % tempfile`],
            ],
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`:diffsplit tempfile`],
            ],
            ['br'],
            ['br'],
            ` To force the differences to be updated use: `,
            ['kbd',
                [`:`],
            ],
            ['code',
                [`diffupdate`],
            ],
            ['br'],
            ['br'],
            ` Jumping to diffs:`,
            ['br'],
            ['kbd',
                [`[`],
            ],
            `+`,
            ['kbd',
                [`C`],
            ],
            ` (or `,
            ['kbd',
                [`shift`],
            ],
            `+`,
            ['kbd',
                [`tab`],
            ],
            `)- Jump backwards to the previous start of a change.`,
            ['br'],
            ['kbd',
                [`]`],
            ],
            `+`,
            ['kbd',
                [`C`],
            ],
            ` (or `,
            ['kbd',
                [`tab`],
            ],
            `) - Jump forwards to the next start of a change.`,
            ['br'],
            ['br'],
            ` Diff copying:`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`[range]diffget`],
            ],
            ` - Modify the current buffer to undo diff with another buffer.`,
            ['br'],
            ['kbd',
                [`:`],
            ],
            ['code',
                [`[range]diffput`],
            ],
            ` - Modify another buffer to undo diff with the current buffer.
                `],
        ]],
    },
    {
        id: 'advanced-hola_spec',
        title: `Hola specific
  extensions (after installing vimrc_zon)`,
        tag: 'h3',
        short: `Hola specific extensions`,
        html: [['p',
            [` bash alias gvim->g: `,
            ['code',
                [`$ g a_file.txt`],
            ],
            ['br'],
            ['code',
                [`zdiff`],
            ],
            `: executing `,
            ['code',
                [`cvsdiff`],
            ],
            ` on all modified (M) files `],
        ]],
    },
];
return E;
});
